import * as React from 'react';
import { token, zVar } from '../../ui/theme';

/*
 * SpectatingBadge — a small "watching" pill pinned top-center of the Stage while
 * a spectator (no seat) is viewing the table, so it's always clear this view is
 * read-only.
 */
export const SpectatingBadge: React.FC = () => (
  <div
    style={{
      position: 'absolute',
      left: '50%',
      top: 8,
      transform: 'translateX(-50%)',
      zIndex: zVar('z-hud'),
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: 'var(--space-1) var(--space-3)',
      borderRadius: 'var(--radius-pill)',
      background: token('color-surface-2'),
      border: `1px solid ${token('color-border')}`,
      color: token('color-muted'),
      fontSize: 'var(--font-size-xs)',
      letterSpacing: 'var(--letter-spacing-wide)',
      textTransform: 'uppercase',
      fontWeight: 700,
    }}
  >
    <span aria-hidden="true">👁</span>
    Spectating
  </div>
);

export default SpectatingBadge;
